import script from "./AiPrompts.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPrompts.vue?vue&type=script&setup=true&lang=js"

import "./AiPrompts.vue?vue&type=style&index=0&id=c50a943c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c50a943c"]])

export default __exports__